<template>
  <div :id="formTargetId" ref="formTarget" class="hs-form-frame"></div>
</template>

<script>
const HUBSPOT_SCRIPT_SRC = "https://js.hsforms.net/forms/embed/v2.js";
let hubspotScriptPromise = null;
let hsFormEventListenerAdded = false;

export default {
  props: {
    dataFormId: {
      type: String,
      default: null,
    },
    dataPortalId: {
      type: String,
      default: null,
    },
    region: {
      type: String,
      default: "na1",
    },
  },
  computed: {
    formTargetId() {
      return `hs-form-${this._uid}`;
    },
    hasIds() {
      return Boolean(this.dataFormId && this.dataPortalId);
    },
  },
  watch: {
    dataFormId: "initForm",
    dataPortalId: "initForm",
  },
  mounted() {
    this.initForm();
  },
  beforeDestroy() {
    this.clearForm();
  },
  methods: {
    initForm() {
      
      if (!hsFormEventListenerAdded) {
        window.addEventListener("hs-form-event:on-submission:success", function (event) {
          window.dataLayer.push({
            event: "hubspot-form-submit",
            "hs-form-guid": event.detail.formId,
            pagePath: window.location.pathname,
          });
        });
        hsFormEventListenerAdded = true;
      }
      if (!this.hasIds) {
        this.clearForm();
        return;
      }

      this.loadHubspotScript()
        .then(() => {
          this.renderForm();
        })
        .catch((error) => {
          console.error("HubSpot form error:", error);
        });
    },
    loadHubspotScript() {
      if (window.hbspt && window.hbspt.forms) {
        return Promise.resolve();
      }

      if (hubspotScriptPromise) {
        return hubspotScriptPromise;
      }

      hubspotScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = HUBSPOT_SCRIPT_SRC;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
          hubspotScriptPromise = null;
          reject(new Error("Failed to load HubSpot forms script"));
        };
        document.head.appendChild(script);
      });

      return hubspotScriptPromise;
    },
    renderForm() {
      const target = this.$refs.formTarget;
      if (!target || !window.hbspt || !window.hbspt.forms) {
        return;
      }

      target.innerHTML = "";
      window.hbspt.forms.create({
        region: this.region,
        portalId: this.dataPortalId,
        formId: this.dataFormId,
        target: `#${this.formTargetId}`,
      });
    },
    clearForm() {
      const target = this.$refs.formTarget;
      if (target) {
        target.innerHTML = "";
      }
    },
  },
};
</script>